// Independent UI only. Native Shopify localization resolves prices/currency on navigation.
(() => {
  'use strict';
  function init() {
    const picker = document.querySelector('[data-kc-market-picker]');
    if (!picker || picker.dataset.kcMarketReady === 'true') return;
    const form = picker.querySelector('#kc-market-form');
    const toggle = picker.querySelector('#kc-market-toggle');
    const menu = picker.querySelector('#kc-market-options');
    const status = picker.querySelector('[data-kc-market-status]');
    const configNode = picker.querySelector('#kc-market-data');
    if (!form || !toggle || !menu || !status || !configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch { return; }
    const buttons = [...menu.querySelectorAll('[data-kc-country]')];
    const desktop = matchMedia('(min-width:1200px) and (hover:hover) and (pointer:fine)');
    picker.dataset.kcMarketReady = 'true';
    let busy = false;

    function close(restoreFocus = false) {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus && desktop.matches) toggle.focus({ preventScroll: true });
    }
    function open(which = 'current') {
      if (!desktop.matches || busy || !buttons.length) return;
      status.hidden = true;
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      const index = which === 'last' ? buttons.length - 1 : which === 'first' ? 0 : Math.max(0, buttons.findIndex(button => button.dataset.kcCountry === config.country));
      buttons[index].focus({ preventScroll: true });
    }
    function reset() {
      busy = false;
      toggle.disabled = false;
      form.removeAttribute('aria-busy');
      buttons.forEach(button => { button.disabled = false; });
      status.hidden = true;
      close();
    }
    function select(country) {
      if (!desktop.matches || busy) return;
      const option = config.options[country];
      if (!option || !option.language || !option.currency || !config.handle) return;
      if (country === config.country && option.language.toLowerCase() === config.language.toLowerCase()) { close(true); return; }
      const destination = new URL(location.href);
      destination.pathname = option.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(config.handle);
      destination.searchParams.set('country', country);
      form.querySelectorAll('input[name="country_code"]').forEach(input => { input.value = country; });
      form.querySelectorAll('input[name="language_code"]').forEach(input => { input.value = option.language; });
      form.querySelectorAll('input[name="return_to"]').forEach(input => { input.value = destination.pathname + destination.search + destination.hash; });
      const detail = { country, language: option.language, currency: option.currency, returnTo: destination.pathname + destination.search + destination.hash };
      if (!picker.dispatchEvent(new CustomEvent('kc:market-change', { bubbles: true, cancelable: true, detail }))) { close(true); return; }
      close();
      busy = true;
      toggle.disabled = true;
      buttons.forEach(button => { button.disabled = true; });
      form.setAttribute('aria-busy', 'true');
      try { form.requestSubmit(); }
      catch {
        reset();
        status.textContent = config.error || 'Please try again.';
        status.hidden = false;
      }
    }
    toggle.addEventListener('click', () => menu.hidden ? open() : close(true));
    toggle.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); open(event.key === 'ArrowUp' ? 'last' : 'first'); }
      if (event.key === 'Escape') { event.preventDefault(); close(true); }
    });
    buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.kcCountry)));
    menu.addEventListener('keydown', event => {
      const current = buttons.indexOf(document.activeElement);
      let next;
      if (event.key === 'ArrowDown') next = (current + 1) % buttons.length;
      if (event.key === 'ArrowUp') next = (current - 1 + buttons.length) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      if (next !== undefined) { event.preventDefault(); buttons[next].focus({ preventScroll: true }); }
      if (event.key === 'Escape') { event.preventDefault(); close(true); }
      if (event.key === 'Tab') close();
    });
    document.addEventListener('pointerdown', event => { if (!picker.contains(event.target)) close(); });
    desktop.addEventListener('change', () => {
      close();
      if (!desktop.matches && picker.contains(document.activeElement)) document.activeElement.blur();
    });
    window.addEventListener('pageshow', reset);
    window.addEventListener('pagehide', () => close());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
